module.exports = __webpack_public_path__ + "static/img/c-info-jt.3ed7344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/c-info-jt.png
// module id = SN/M
// module chunks = 31